import { lazy } from 'react';

const SignUp = lazy(() =>
  import(/* webpackChunkName: "SignUp" */ '@common2/Authorization/SignUp/SignUp')
);

export default SignUp;
